import React from "react";
import { Dropdown, Box } from "samba-ui";

type Option = { label: string; value: string };
type Props = {
  users: string[];
  selected: string | null;
  onSelect: (user: string) => void;
};

export default function UserSelect({ users, selected, onSelect }: Props) {
  const options: Option[] = users.map(u => ({ label: u, value: u }));
  const selectedOption = selected ? { label: selected, value: selected } : null;
  return (
    <Box width={280} mb={3}>
      <Dropdown
        options={options}
        placeholder="Pick a user…"
        selected={selectedOption}
        onSelect={(opt: Option) => opt && onSelect(opt.value)}
      />
    </Box>
  );
}
